// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/expense-payments',
        component: () =>
            import(/* webpackChunkName: "accounts-payable.expense-payments" */ '@/pages/[organisation]/payables/expense-payments/expense-payments.vue'),
        name: 'accounts-payable.expense-payments.search-expense-payments',
        meta: {
            loginRequired: true,
            permission: 'access.payables.expense-payment.view-expense-payments',
        },
        children: [
            {
                path: ':paymentId/redo',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.expense-payments" */ '@/pages/[organisation]/payables/expense-payments/redo-expense-payment.vue'),
                name: 'accounts-payable.expense-payments.redo-expense-payment',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.expense-payment.create-expense-payment',
                },
            },
        ],
    },
];
